import BaseApiService from './baseApiService';
import {
    CreateUserCommand,
    GetUserInfoVM,
    SetAuthorizationNumberCommand,
    UpdateUserCommand,
    UserDetailsVM,
    UserShortInfo,
    UserVM
} from '../contracts';

class UsersApiService extends BaseApiService {
    getUsers = () => {
        return this.get<UserVM[]>('users');
    };

    getUser = (id: string) => {
        return this.get<UserDetailsVM>(`users/${id}`);
    };

    addUser = async (request: CreateUserCommand) => {
        await this.post('users', request);
    };

    updateUser = (request: UpdateUserCommand) => {
        return this.put('users', request);
    };

    setAuthorizationNumber = (request: SetAuthorizationNumberCommand) => {
        return this.post('users/set-authorization-number', request);
    };

    getAlternateUsers = (department: string) => {
        return this.get<UserShortInfo[]>('users/alternate-conformists', { params: { department } });
    };

    lockUser = async (userId: string) => {
        await this.post('users/lock', { userId });
    };

    unblockedUser = async (userId: string) => {
        await this.post('users/unlock', { userId });
    };

    checkUser = async (username: string) => {
        return await this.post<boolean>('users/exists', { username });
    };

    getCurrentUserInfo = () => {
        return this.get<GetUserInfoVM>('users/current/info');
    };
}

export default new UsersApiService();
